/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'



import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';


import MyaccountForm from "../MyaccountForm.js"



function Index(props) {
   
  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  var selectedUser = props.selectedUser;
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
    if(role !="admin"){
      selectedUser= userinfo['id']
    }
  }
  return (
      <MyaccountForm selectedUser={selectedUser} role={role}/>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
